import {Carousel} from "@mantine/carousel";
import {Box, Image, Text} from "@mantine/core";
import { useRef } from '@wordpress/element';
import Autoplay from 'embla-carousel-autoplay';
import CategoryPlaceholderImage from '../../../../../assets/images/category_placeholder.png';

const _CategoryDiscountOffers = ({component}) => {
    const autoplay = useRef(Autoplay({ delay: 4000 }));

    return (
        <Box
            bg={component?.customize_styles?.general_decoration?.background_color}
            mx={component?.customize_styles?.general_decoration?.margin_x}
            my={component?.customize_styles?.general_decoration?.margin_y}
            px={component?.customize_styles?.general_decoration?.padding_x}
            py={component?.customize_styles?.general_decoration?.padding_y}
            style={{
                boxShadow: `${component?.customize_styles?.general_decoration?.shadow_offset_x}px ${component?.customize_styles?.general_decoration?.shadow_offset_y}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px #00000014`,
                borderRadius: `${component?.customize_styles?.general_decoration?.border_radius}px`,
                border: `${component?.customize_styles?.general_decoration?.border_width}px solid ${component?.customize_styles?.general_decoration?.border_color}`,
            }}
        >
            <Text
                // bg={component?.customize_styles?.text_decoration?.background_color}
                fz={component?.customize_styles?.text_decoration?.font_size}
                fw={component?.customize_styles?.text_decoration?.font_weight}
                c={component?.customize_styles?.text_decoration?.color}
                mx={component?.customize_styles?.text_decoration?.margin_x}
                my={component?.customize_styles?.text_decoration?.margin_y}
                px={component?.customize_styles?.text_decoration?.padding_x}
                py={component?.customize_styles?.text_decoration?.padding_y}
            >
                {component?.customize_properties?.label}
            </Text>
            <Carousel
                slideSize="30%"
                loop
                align="start"
                withControls={false}
                plugins={[autoplay.current]}
                onMouseEnter={autoplay.current.stop}
                onMouseLeave={autoplay.current.reset}

            >
                {
                    component?.items?.map((item, index) => (
                        <Carousel.Slide key={item.id}>
                            <Box
                                pos="relative"
                                mx={component?.customize_styles?.box_decoration?.margin_x}
                                my={component?.customize_styles?.box_decoration?.margin_y}
                                px={component?.customize_styles?.box_decoration?.padding_x}
                                py={component?.customize_styles?.box_decoration?.padding_y}
                                bg={component?.customize_styles?.box_decoration?.background_color}
                                style={{
                                    borderRadius: `${component?.customize_styles?.box_decoration?.border_radius}px`,
                                    border: `${component?.customize_styles?.box_decoration?.border_width}px solid ${component?.customize_styles?.box_decoration?.border_color}`,
                                    boxShadow: `${component?.customize_styles?.box_decoration?.shadow_offset_x}px -${component?.customize_styles?.box_decoration?.shadow_offset_y}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px #00000014`,

                                }}

                            >
                                <Image
                                    width={component?.customize_styles?.image_decoration?.width}
                                    height={component?.customize_styles?.image_decoration?.height}
                                    fit="cover"
                                    src={item.image_url}
                                    fallbackSrc={CategoryPlaceholderImage}
                                    // bg={component?.customize_styles?.image_decoration?.color}
                                    alt={item.name}
                                    radius={component?.customize_styles?.image_decoration?.radius}
                                />
                                <Text pos="absolute" top={5} left={5} style={{ borderRadius: '5px' }} bg="#00743da8" c='#fff' fw={700} size={10} lh={1} ta="center" py={4} px={8}>10% OFF</Text>
                                <Text pos="absolute" bottom={5} right={5} style={{ borderRadius: '5px' }} bg="#00743da8" c='#fff' fw={700} size={9} lh={1} ta="center" py={4} px={8}>1 Day Left</Text>
                            </Box>
                        </Carousel.Slide>
                    ))
                }
            </Carousel>
        </Box>
    )
}
export default _CategoryDiscountOffers;